import styled from '@emotion/styled';

export const TableContainer = styled.div`
	width: 100%;
	background-color: #fff;
	border: 1px solid ${(props) => props.theme.colors.gray100};
	border-radius: ${(props) => props.theme.effects.radiusLg};
	box-shadow: ${(props) => props.theme.effects.shadowSm};
	overflow: hidden;
`;

export const Table = styled.table`
	display: grid;
	grid-template-columns: minmax(8rem, 10rem) minmax(20rem, 1fr) minmax(8rem, 10rem) minmax(8rem, 10rem) minmax(12rem, 16rem);
	grid-auto-rows: minmax(5.2rem, auto);
	max-width: 100%;
	width: 100%;
`;

export const TableHeaderCell = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1.4rem 1.2rem;
	background-color: ${(props) => props.theme.colors.primary50};
	color: ${(props) => props.theme.colors.grayDarker};
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: ${(props) => props.theme.ui.lineHeight.ui};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.body};
	min-width: 10rem;
	border-bottom: 1px solid ${(props) => props.theme.colors.gray100};
`;

export const TableCell = styled.div`
	min-height: 6.4rem;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1.2rem 1.2rem;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.ui};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.body};
	cursor: pointer;
	border-bottom: 1px solid ${(props) => props.theme.colors.gray100};
	overflow: hidden;
	transition:
		background-color ${(props) => props.theme.effects.transitionFast},
		color ${(props) => props.theme.effects.transitionFast};

	&:hover {
		background-color: ${(props) => props.theme.colors.primary50};
	}

	&.start {
		justify-content: flex-start;
	}
`;

export const LabelImportant = styled.span`
	display: inline-flex;
	align-items: center;
	padding: 0.4rem 1rem;
	border-radius: ${(props) => props.theme.effects.radiusFull};
	background: ${(props) => props.theme.colors.primary400};
	height: 2.8rem;
	color: #fff;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
`;
